import {Card, SectionIntro, Stack} from '@primer/react-brand'

import Spacer from '../../components/Spacer/Spacer'

import {resourcesIcons} from './Resources.data'

export interface ResourcesProps {
  title: string
  cards: Array<{
    id: string
    title: string
    description: string
    icon: keyof typeof resourcesIcons
    link: {
      href: string
      label: string
    }
  }>
}

const defaultProps: Partial<ResourcesProps> = {}

const Resources: React.FC<ResourcesProps> = props => {
  const initializedProps = {...defaultProps, ...props}

  const {title, cards} = initializedProps

  return (
    <section id="resources">
      <div className="lp-Container">
        <SectionIntro align="center" fullWidth style={{padding: '0'}}>
          <SectionIntro.Heading size="3" className="text-wrap-balance">
            {title}
          </SectionIntro.Heading>
        </SectionIntro>

        <Spacer size="64px" size768="80px" />

        <Stack direction={{narrow: 'vertical', regular: 'horizontal', wide: 'horizontal'}} gap="normal" padding="none">
          {cards.map(card => {
            const Icon = resourcesIcons[card.icon]

            return (
              <div className="lp-Resources-card" key={card.id}>
                <Card ctaText={card.link.label} href={card.link.href}>
                  <Card.Icon icon={Icon} color="green" hasBackground />
                  <Card.Heading>{card.title}</Card.Heading>
                  <Card.Description>{card.description}</Card.Description>
                </Card>
              </div>
            )
          })}
        </Stack>

        <Spacer size="80px" size768="184px" />
      </div>
    </section>
  )
}

export default Resources
